/* eslint-disable camelcase */
export enum AcademyTypes {
  GET_AGENDA_REQUEST = '@academy/GET_AGENDA_REQUEST',
  GET_AGENDA_SUCCESS = '@academy/GET_AGENDA_SUCCESS',
  GET_AGENDA_FAILURE = '@academy/GET_AGENDA_FAILURE',
  GET_LIVE_NOW_REQUEST = '@academy/GET_LIVE_NOW_REQUEST',
  GET_LIVE_NOW_SUCCESS = '@academy/GET_LIVE_NOW_SUCCESS',
  GET_LIVE_NOW_FAILURE = '@academy/GET_LIVE_NOW_FAILURE',
  GET_CONTENTS_REQUEST = '@academy/GET_CONTENTS_REQUEST',
  GET_CONTENTS_SUCCESS = '@academy/GET_CONTENTS_SUCCESS',
  GET_CONTENTS_FAILURE = '@academy/GET_CONTENTS_FAILURE',
  GET_MY_SUBSCRIPTIONS_REQUEST = '@academy/GET_MY_SUBSCRIPTIONS_REQUEST',
  GET_MY_SUBSCRIPTIONS_SUCCESS = '@academy/GET_MY_SUBSCRIPTIONS_SUCCESS',
  GET_MY_SUBSCRIPTIONS_FAILURE = '@academy/GET_MY_SUBSCRIPTIONS_FAILURE',
  SUBSCRIBE_REQUEST = '@academy/SUBSCRIBE_REQUEST',
  SUBSCRIBE_SUCCESS = '@academy/SUBSCRIBE_SUCCESS',
  SUBSCRIBE_FAILURE = '@academy/SUBSCRIBE_FAILURE',
  UNSUBSCRIBE_REQUEST = '@academy/UNSUBSCRIBE_REQUEST',
  UNSUBSCRIBE_SUCCESS = '@academy/UNSUBSCRIBE_SUCCESS',
  UNSUBSCRIBE_FAILURE = '@academy/UNSUBSCRIBE_FAILURE',
  SET_LIVE_NOW = '@academy/SET_LIVE_NOW',
  SET_FLOATING_STATE = '@academy/SET_FLOATING_STATE',
}

export type AcademyFloatingState = 'expanded' | 'minimized';

export type AcademyLiveStatus = 'scheduled' | 'live' | 'finished' | 'canceled';
export type AcademyProvider = 'youtube' | 'vimeo';

export interface AcademyLive {
  id: number;
  title: string;
  description: string;
  speaker: string;
  scheduled_at: string;
  ends_at: string | null;
  status: AcademyLiveStatus;
  provider: AcademyProvider;
  video_id: string;
  embed_url: string | null;
  recording_video_id: string | null;
  recording_embed_url: string | null;
  thumbnail_url: string | null;
  category: string | null;
  content_type: string | null;
  published: boolean;
  subscribers_count: number;
}

export interface AcademySubscription {
  id: number;
  live_id: number;
  name: string;
  email: string;
  ddd: string;
  phone: string;
  created_at: string;
  live: AcademyLive | null;
}

export interface AcademySubscriptionPayload {
  live_id: number;
  name: string;
  email: string;
  ddd: string;
  phone: string;
}

export interface RequestFlags {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface AcademyState {
  agenda: AcademyLive[];
  liveNow: AcademyLive | null;
  contents: AcademyLive[];
  mySubscriptions: AcademySubscription[];
  floatingState: AcademyFloatingState;
  request: {
    agenda: RequestFlags;
    liveNow: RequestFlags;
    contents: RequestFlags;
    mySubscriptions: RequestFlags;
    subscribe: RequestFlags;
  };
}
